function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122.438 6.3V164.9C122.431 166.104 122.07 167.28 121.397 168.279C120.725 169.277 119.772 170.054 118.659 170.512C117.936 170.854 117.143 171.021 116.344 171C115.542 171.005 114.747 170.851 114.004 170.547C113.262 170.244 112.587 169.796 112.017 169.231L61.5 118.601L10.9828 169.231C10.1259 170.077 9.03771 170.651 7.85558 170.879C6.67346 171.107 5.45036 170.979 4.34062 170.512C3.22779 170.054 2.27517 169.277 1.60283 168.279C0.930488 167.28 0.568505 166.104 0.5625 164.9V6.3C0.5625 4.68218 1.20452 3.13062 2.34732 1.98665C3.49012 0.842677 5.04009 0.200001 6.65625 0.200001H116.344C117.96 0.200001 119.51 0.842677 120.653 1.98665C121.795 3.13062 122.438 4.68218 122.438 6.3Z",
  fill: "black"
});
const SvgFavoriteIconCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 123 172",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteIconCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favoriteIconCheck.8702045a.svg";
export { ForwardRef as ReactComponent };